import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { register } from "../../api/user.api";
import { Alert, Button, Divider, TextField, Typography } from "@mui/material";
import { useSnackbar } from "../../context/snackbar.context";

const RegistrationPage = () => {
  const [formData, setFormData] = useState({
    nickname: "",
    email: "",
    password: "",
    fullName: "",
    accessCode: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrors({});
    register(formData)
      .then(() => {
        showSnackbar("Registration completed!", "success");
        navigate("/login");
      })
      .catch((error) => {
        showSnackbar("Registration failed!", "error");
        if (error.response && error.response.status === 400) {
          setErrors(error.response.data.errors || {});
        } else {
          setErrors({ general: "Unknown error" });
        }
      });
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Typography variant="h3">Registration</Typography>
        <div>
          <TextField
            id="nickname"
            label="Nickname"
            name="nickname"
            variant="outlined"
            fullWidth
            value={formData.nickname}
            onChange={(e) => handleChange(e)}
            error={Boolean(errors.nickname)}
            helperText={errors.nickname ? errors.nickname[0] : ""}
          />
        </div>
        <div>
          <TextField
            id="fullName"
            label="Full Name"
            name="fullName"
            variant="outlined"
            fullWidth
            value={formData.fullName}
            onChange={(e) => handleChange(e)}
            error={Boolean(errors.fullName)}
            helperText={errors.fullName ? errors.fullName[0] : ""}
          />
        </div>
        <div>
          <TextField
            id="email"
            label="Email"
            name="email"
            variant="outlined"
            type="email"
            fullWidth
            value={formData.email}
            onChange={(e) => handleChange(e)}
            error={Boolean(errors.email)}
            helperText={errors.email ? errors.email[0] : ""}
          />
        </div>
        <div>
          <TextField
            id="password"
            label="Password"
            name="password"
            variant="outlined"
            type="password"
            fullWidth
            value={formData.password}
            onChange={(e) => handleChange(e)}
            error={Boolean(errors.password)}
            helperText={errors.password ? errors.password[0] : ""}
          />
        </div>
        <Divider />
        <div>
          <TextField
            id="accesscode"
            label="Access Code"
            name="accessCode"
            variant="outlined"
            type="password"
            fullWidth
            value={formData.accessCode}
            onChange={(e) => handleChange(e)}
          />
          <Typography>
            This application is not for public! - Registration only with an
            access code.
          </Typography>
        </div>
        <Button variant="contained" type="submit">
          Register
        </Button>

        <div>
          {errors.generalErrors && (
            <Alert
              severity="error"
              onClose={() => {
                setErrors({});
              }}
            >
              {errors.generalErrors[0]}
            </Alert>
          )}
        </div>
        {errors.general && <div>{errors.general}</div>}
      </form>
    </div>
  );
};

export default RegistrationPage;
